<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>
            <span v-if="showDetails && label">{{label}}</span>
            <span v-else>ContentId</span>
            Claims Log
          </p>
          <div  v-if="showDetails && label" >
            <Filters />
            <el-button @click="goBack" class="ml5">Go back</el-button>
          </div>
          <div v-else-if="tabs === 'claims'">
            <ClaimsFilters />
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Claims" name="claims">
            <TodayTable />
          </el-tab-pane>
          <el-tab-pane label="Summary" name="summary">
            <DetailsTable v-if="showDetails" />
            <Table v-else />
            <Dialog />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/youtube/claim-log/Table'
import Dialog from '../components/youtube/claim-log/Dialog'
import {mapState, mapMutations, mapActions} from 'vuex'
import DetailsTable from "@/modules/admin/cms/components/youtube/claim-log/DetailsTable.vue";
import Filters from "@/modules/admin/cms/components/youtube/claim-log/Filters.vue";
import ClaimsFilters from "@/modules/admin/cms/components/youtube/claim-log/ClaimsFilter.vue";
import TodayTable from "@/modules/admin/cms/components/youtube/claim-log/TodayTable.vue";

export default {
  components: {
    TodayTable,
    Filters,
    ClaimsFilters,
    DetailsTable,
    Table,
    Dialog
  },
  data() {
    return {
      tabs: 'claims'
    }
  },

  computed: {
    ...mapState('youtubeClaimLog', ['loading', 'showDetails', 'label'])
  },

  methods: {
    ...mapMutations('youtubeClaimLog', ['setShowDetails', "setSelectedLabel", "setClaimList", "setPage", "setFilter", "setPage", "setPageSize"]),
    ...mapActions('youtubeClaimLog', ['read', "getTodayClaims"]),
    goBack () {
      this.setSelectedLabel({})
      this.setClaimList({})
      this.setShowDetails(false)
      this.setFilter({})
      this.setPage(1)
    },
    tabClick(tab){
      this.setClaimList({})
      this.setShowDetails(false)
      this.setFilter({})
      this.setPageSize(30)
      this.setPage(1)
      if(tab.name === 'claims') {
        this.getTodayClaims()
      }
      else{
        this.read()
      }
    }
  }
}
</script>
